export async function handleApiRequest<T>(operation: () => Promise<T>): Promise<T> {
  try {
    return await operation();
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message || 'API request failed');
  }
}
